import type { ParagraphProps } from '@/components/atomic/atoms/data-display/typography/paragraph/typings';
import { generateStylesheetRules } from '@/utils/generate-stylesheet-rules';
import styled, { CSSObject } from '@emotion/styled';

const Paragraph = styled.p<ParagraphProps>(
	({
		theme,
		$textAlign = 'left',
		$color = theme.colors.primaryBrandColor,
		$fontSize = 14,
		$fontWeight = 400,
		$fontStyle = 'normal',
		$lineHeight = '19px',
		$letterSpacing = '0.2px',
		$fontFamily = theme.font.families.secondary.default,
		$textTransform,
		$breakpoints,
		$margin,
		$maxWidth,
	}) => {
		const paragraphProps = {
			$textAlign,
			$color,
			$fontSize,
			$fontWeight,
			$fontStyle,
			$lineHeight,
			$letterSpacing,
			$fontFamily,
			$textTransform,
			$margin,
			$maxWidth,
		};

		const style: CSSObject = generateStylesheetRules(
			paragraphProps,
			Object.keys(paragraphProps),
		);

		if ($breakpoints !== undefined) {
			Object.entries($breakpoints).forEach(([breakpoint, props]) => {
				const breakpointKey = `@media (min-width: ${breakpoint}px)`;

				const nestedStyle: CSSObject = generateStylesheetRules(
					props,
					Object.keys(props),
				);

				if (!style[breakpointKey]) style[breakpointKey] = nestedStyle;
			});
		}

		return style;
	},
);

export default Paragraph;
